import { render } from "./Card1.vue?vue&type=template&id=50da0a20"
import script from "./Card1.vue?vue&type=script&lang=js"
export * from "./Card1.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vistream-spa-cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__